import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const AboutBuildingMultiAds = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={styles['wrapper']}>
      <ArticleParagraph2 as="p">{children}</ArticleParagraph2>
    </div>
  );
};
